import React, { useState, ReactNode, useEffect, useContext } from "react";
import styled from "styled-components";

import { Alert, Layout } from "antd";
import ScreenLoader from "../ScreenLoader";

import Navigation from "./navigation";
import Header from "./header";

import Breadcrumbs from "./breadcrumbs";
import { Context } from "../../context";

const { Content } = Layout;

const NewLayout = styled(Layout)`
    height: 100vh;
    overflow: hidden;
`;

interface Props {
    children: ReactNode;
}

const MainLayout: React.FC<Props> = ({ children }) => {
    const {
        state: { brand: brandData, user },
    } = useContext(Context);
    const [collapsed, setCollapsed] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(true);
    const tenantName = user?.tenants?.[0]?.name;
    const showBrandResolutionWarning = !!user?.tenants?.length && !brandData;

    useEffect(() => {
        const timer = setTimeout(() => {
          setLoader(false);
        }, 4000);
        return () => clearTimeout(timer);
      }, []);

    const toggle = () => {
        setCollapsed(!collapsed);
    };

    return (
        <NewLayout data-index="layout">
          {
            !loader ?
              <>
                <Navigation collapsed={collapsed} />
                <Layout>
                    <Header collapsed={collapsed} toggle={toggle} />
                    <Content>
                        {showBrandResolutionWarning && (
                            <Alert
                                type="warning"
                                showIcon
                                style={{ margin: "16px 24px 0" }}
                                message="Brand could not be resolved for your account."
                                description={`Your tenant (${tenantName}) is not linked to an active brand in the content service. Brand-specific pages such as MDOR documents, properties, and company information will appear empty until this is corrected.`}
                            />
                        )}
                        <Breadcrumbs />
                        {children}
                    </Content>
                </Layout>
              </> : <ScreenLoader visible={true} />
          }
        </NewLayout>
    );
};

export default MainLayout;
